import React, { useState } from "react";
const SettingContext = React.createContext({});

export default SettingContext;

export const SettingProvider = ({ children }: React.PropsWithChildren) => {

  const [mProductShow, setMProductShow] = useState(false);
  const [mProductShowImg, setMProductShowImg] = useState(false);
  const [mProductShowDetail, setMPRoductShowDetail] = useState({});
  const [mProductIndex, setMProductIndex] = useState(0);

  const contextData = {
    mProductShow,
    setMProductShow,
    mProductShowImg,
    setMProductShowImg,
    mProductShowDetail,
    setMPRoductShowDetail,
    mProductIndex,
    setMProductIndex
  };

  return (
    <SettingContext.Provider value={contextData}>
      {children}
    </SettingContext.Provider>
  );
};
